<template>
  <div
    class="flex items-start gap-3 rounded-lg border-[1.5px] border-warning-500 bg-warning-50 px-4 py-3 text-warning-600"
    data-testid="no-recipients-banner"
    role="alert"
  >
    <VIcon icon="custom:alertTriangle" size="20" class="mt-0.5 shrink-0 text-warning-600" />
    <p class="text-sm font-semibold">
      {{
        t(
          'No consulting physician could be found matching the selected consultation criteria. Please review urgency, speciality or timing.'
        )
      }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped></style>
